<template>
  <w-icon-wrapper icon-name='work-color-no-selection-icon'>
    <g
      id="Gruppe_25614"
      data-name="Gruppe 25614"
      transform="translate(-1518 -789)"
    >
      <rect
        id="Rechteck_4043"
        data-name="Rechteck 4043"
        width="24"
        height="24"
        transform="translate(1518 789)"
        fill="none"
      />
      <g
        id="_86_Keine_Farbauswahl_Icon"
        data-name="86 Keine_Farbauswahl_Icon"
        transform="translate(1518.062 789.037)"
      >
        <path
          id="Pfad_55828"
          data-name="Pfad 55828"
          d="M16.539,19.743a6.51,6.51,0,0,1-10.78-.64,6.39,6.39,0,0,1-.41-5.75l-1.75-1a8.5,8.5,0,0,0,7.77,11.95,8.4,8.4,0,0,0,6.91-3.56Z"
          transform="translate(0 -0.34)"
          fill="currentColor"
        />
        <path
          id="Pfad_55829"
          data-name="Pfad 55829"
          d="M22.785,18.624l-3.274-1.869a8.338,8.338,0,0,0-.966-5.263L12.579.76a1.569,1.569,0,0,0-2.731,0L5.421,8.728,2.078,6.819a.988.988,0,1,0-.986,1.712L21.8,20.335a.988.988,0,1,0,.986-1.712ZM11.219,2.353l5.6,10.093a6.22,6.22,0,0,1,.809,3.236L7.136,9.7Z"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconColorNoSelection' };
</script>
